import React from "react";
import { GetResourceSearchResultsItem } from "@/api/getResourceSearchResults/types";
import { ResourceCardV2 } from "@/modules/hub/features/ResourceLibraryV2/components/ResourceCardV2/ResourceCardV2";

interface PodcastCardV2Props {
  resource: GetResourceSearchResultsItem;
  showFeaturedBadge?: boolean;
  onToggleFavorite?: (uuid: string) => void;
}

export function PodcastCardV2({
  resource,
  showFeaturedBadge = false,
  onToggleFavorite,
}: PodcastCardV2Props) {
  return (
    <ResourceCardV2
      onToggleFavorite={onToggleFavorite}
      resource={resource}
      showFeaturedBadge={showFeaturedBadge}
      showTradeBadge={false}
    />
  );
}
